<template>
  <div class="channel" v-wechat-title="$t($route.meta.title) + ' - ' + $t('app.name')">
    <NavHome class="channelNav" v-once/>
    <div class="results">
      <div class="results-wrap">
        <ContentZh/>
      </div>
    </div>
    <Footer style="padding-top: 10px;background-color: transparent;" />
  </div>
</template>

<script>
import NavHome from '../layout/NavHome'
import Footer from '../layout/Footer'
import ContentZh from './zh-CN/GuideContent'

export default {
  name: 'Channel',
  components: { NavHome, Footer, ContentZh },
  mounted () {
    this.$nextTick(() => {
      let resultDom = document.querySelector('.results')
      let footer = document.querySelector('footer')
      let minHeight = (this._h.getWinHeight() - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(resultDom).top) - this._h.getRealElSize(footer).height - 18))
      resultDom.style.minHeight = (minHeight > 400 ? minHeight : 400) + 'px'
    })
  }
}
</script>
<style scoped>
  /* .channel{
    background: url("~@/assets/images/channel/bg.png") top right no-repeat transparent;
    background-size: 70% 100%;
  } */
  .results{
    position: relative;
    padding: 15px 0 5px;
  }
  .results-wrap{
    width: 75%;
    margin: 0 auto;
    padding-bottom: 20px;
    max-width: 960px;
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  .channel >>> footer .wrap{
    width: 75%;
    padding-right: 17.5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/Guide.vue